'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SNOWPLOW_CDN = exports.SNOWPLOW_CDN = '//static.hudl.com/uat/2.13.0/ayN19xAmEN8pEGaM.js';

// snowplow methods
var NEW_TRACKER = exports.NEW_TRACKER = 'newTracker';
var SET_USERID = exports.SET_USERID = 'setUserId';
var TRACK_CUSTOM_EVENT = exports.TRACK_CUSTOM_EVENT = 'trackSelfDescribingEvent';
var TRACK_PAGE_VIEW = exports.TRACK_PAGE_VIEW = 'trackPageView';
var ENABLE_ACTIVITY_TRACKING = exports.ENABLE_ACTIVITY_TRACKING = 'enableActivityTracking';

// schema
var SESSION_HEARTBEAT_EVENT_SCHEMA = exports.SESSION_HEARTBEAT_EVENT_SCHEMA = 'iglu:com.hudl/heartbeat_event/jsonschema/1-0-0';
var SESSION_VIEW_EVENT_SCHEMA = exports.SESSION_VIEW_EVENT_SCHEMA = 'iglu:com.hudl/view_event/jsonschema/1-0-0';

var VIDEO_ACTIVITY_HEARTBEAT_EVENT_SCHEMA = exports.VIDEO_ACTIVITY_HEARTBEAT_EVENT_SCHEMA = 'iglu:com.hudl/video_playback_heartbeat_event/jsonschema/1-0-0';

var APPLICATION_ENTITY_SCHEMA = exports.APPLICATION_ENTITY_SCHEMA = 'iglu:com.hudl/application_entity/jsonschema/1-0-0';
var PAGE_ENTITY_SCHEMA = exports.PAGE_ENTITY_SCHEMA = 'iglu:com.hudl/page_entity/jsonschema/2-0-1';
var USER_ENTITY_SCHEMA = exports.USER_ENTITY_SCHEMA = 'iglu:com.hudl/user_entity/jsonschema/4-0-1';
var TEAM_ENTITY_SCHEMA = exports.TEAM_ENTITY_SCHEMA = 'iglu:com.hudl/team_entity/jsonschema/4-0-0';
var VIDEO_ENTITY_SCHEMA = exports.VIDEO_ENTITY_SCHEMA = 'iglu:com.hudl/video_entity/jsonschema/2-0-0';
var PLAYLIST_ENTITY_SCHEMA = exports.PLAYLIST_ENTITY_SCHEMA = 'iglu:com.hudl/playlist_entity/jsonschema/2-0-1';
var PLAYLIST_CLIP_ENTITY_SCHEMA = exports.PLAYLIST_CLIP_ENTITY_SCHEMA = 'iglu:com.hudl/playlist_clip_entity/jsonschema/1-0-0';
var EVENT_PLAYER_ENTITY_SCHEMA = exports.EVENT_PLAYER_ENTITY_SCHEMA = 'iglu:com.hudl/event_player_entity/jsonschema/1-0-0';
var EVENT_TEAM_ENTITY_SCHEMA = exports.EVENT_TEAM_ENTITY_SCHEMA = 'iglu:com.hudl/event_team_entity/jsonschema/1-0-0';
var EVENT_COMPETITION_ENTITY_SCHEMA = exports.EVENT_COMPETITION_ENTITY_SCHEMA = 'iglu:com.hudl/event_competition_entity/jsonschema/1-0-0';
var USER_TEAM_ENTITY_SCHEMA = exports.USER_TEAM_ENTITY_SCHEMA = 'iglu:com.hudl/user_team_entity/jsonschema/1-0-0';
var USER_ORG_ENTITY_SCHEMA = exports.USER_ORG_ENTITY_SCHEMA = 'iglu:com.hudl/user_org_entity/jsonschema/1-0-0';

var VIDEO_INTEGRATION_EVENT_SCHEMA = exports.VIDEO_INTEGRATION_EVENT_SCHEMA = 'iglu:com.hudl/video_integration_event/jsonschema/1-0-3';
var WYSCOUT_USER_ENTITY_SCHEMA = exports.WYSCOUT_USER_ENTITY_SCHEMA = 'iglu:com.hudl/wyscout_user_entity/jsonschema/1-0-0';
var WYSCOUT_VIDEO_ENTITY_SCHEMA = exports.WYSCOUT_VIDEO_ENTITY_SCHEMA = 'iglu:com.hudl/wyscout_video_entity/jsonschema/1-0-0';

var GSL_COMPETITION_SCHEMA = exports.GSL_COMPETITION_SCHEMA = 'iglu:com.hudl/gsl_competition_entity/jsonschema/1-0-0';
var GSL_COMPETITION_PERIOD_SCHEMA = exports.GSL_COMPETITION_PERIOD_SCHEMA = 'iglu:com.hudl/gsl_competition_period_entity/jsonschema/1-0-0';
var GSL_TEAM_SCHEMA = exports.GSL_TEAM_SCHEMA = 'iglu:com.hudl/gsl_team_entity/jsonschema/1-0-0';
var GSL_FIXTURE_SCHEMA = exports.GSL_FIXTURE_SCHEMA = 'iglu:com.hudl/gsl_fixture_entity/jsonschema/1-0-0';
var GSL_PLAYER_SCHEMA = exports.GSL_PLAYER_SCHEMA = 'iglu:com.hudl/gsl_player_entity/jsonschema/1-0-0';
var GSL_VIDEO_SCHEMA = exports.GSL_VIDEO_SCHEMA = 'iglu:com.hudl/gsl_video_entity/jsonschema/1-0-0';
var GSL_CLIP_SCHEMA = exports.GSL_CLIP_SCHEMA = 'iglu:com.hudl/gsl_clip_entity/jsonschema/1-0-0';

var CONTENT_SEARCH_EVENT_SCHEMA = exports.CONTENT_SEARCH_EVENT_SCHEMA = 'iglu:com.hudl/content_search_event/jsonschema/1-0-0';
var CONTENT_FILTER_EVENT_SCHEMA = exports.CONTENT_FILTER_EVENT_SCHEMA = 'iglu:com.hudl/content_filter_event/jsonschema/2-0-0';
var CONTENT_PLAYBACK_EVENT_SCHEMA = exports.CONTENT_PLAYBACK_EVENT_SCHEMA = 'iglu:com.hudl/content_playback_event/jsonschema/2-0-0';

var UNIFIED_PRODUCT_INSIGHTS_MODULE_EVENT_SCHEMA = exports.UNIFIED_PRODUCT_INSIGHTS_MODULE_EVENT_SCHEMA = 'iglu:com.hudl/unified_product_insights_module_event/jsonschema/1-0-0';
var UNIFIED_PRODUCT_PLAYLISTS_EVENT_SCHEMA = exports.UNIFIED_PRODUCT_PLAYLISTS_EVENT_SCHEMA = 'iglu:com.hudl/unified_product_playlists_event/jsonschema/1-0-0';

var FAN_CONTENT_SEARCH_EVENT_SCHEMA = exports.FAN_CONTENT_SEARCH_EVENT_SCHEMA = 'iglu:com.hudl/content_search_event/jsonschema/2-0-0';

// debounce
var DEBOUNCE_MS = exports.DEBOUNCE_MS = 400;

// heartbeat interval variance allowed (+25%)
var MAX_HEARTBEAT_VARIANCE = exports.MAX_HEARTBEAT_VARIANCE = 1.25;